import { NavLink } from "react-router-dom";
import logo from "../assets/shaszstudioslogo.png";

const Logo = () => {
  return (
    <NavLink to="/" className="inline-block">
      <img
        src={logo}
        className="block h-10 w-auto md:h-16 drop-shadow-lg" // h-10 for mobile, h-16 for desktop
        alt="logo"
        style={{
          maxWidth: "140px",
          filter:
            "drop-shadow(0 4px 6px rgba(37, 34, 34, 0.415)) invert(1) sepia(0.3) hue-rotate(170deg) saturate(1.2)",
        }} // optional: limit max width
      />
    </NavLink>
  );
};

export default Logo;
